import { render, staticRenderFns } from "./OrderComments.vue?vue&type=template&id=3117150e&scoped=true&"
import script from "./OrderComments.vue?vue&type=script&lang=js&"
export * from "./OrderComments.vue?vue&type=script&lang=js&"
import style0 from "./OrderComments.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderComments.vue?vue&type=style&index=1&id=3117150e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3117150e",
  null
  
)

export default component.exports